import axios from "../axiosPlugin.js";

export const getNewsListService = data => {
  return axios({
    url: "/api/cl/news/list",
    method: "get",
    data: {
      data,
    },
  });
}

export const getmailingOptionListService = data => {
  return axios({
    url: "/api/cl/mailing/options-list",
    method: "get",
    data: {
      data,
    },
  });
}

export const updateStatusService = data => {
  return axios({
    url: `/api/cl/news/updateStatus?id=${data.id}`,
    method: "put",
    data: { data },
  });
}

export const createNewsService = data => {
  return axios({
    url: "/api/cl/news/create",
    method: "post",
    data: { data },
  });
}

export const updateNewsService = data => {
  return axios({
    url: "/api/cl/news/update",
    method: "put",
    data: { data },
  });
}

export const getNewsDetailService = data => {
  return axios({
    url: `/api/cl/news/detail/${data.id}`,
    method: "get",
    data: {},
  });
}

export const deleteNewsService = data => {
  return axios({
    url: `/api/cl/news/delete/${data.id}`,
    method: "delete",
    data: {},
  });
}

export const sendTestEmailService = data => {
  return axios({
    url: `/api/cl/news/test-email?id=${data.id}&email=${data.email}`,
    method: "put",
    data: {},
  });
}